import { render } from "./AuthPopup.vue?vue&type=template&id=913abc7c"
import script from "./AuthPopup.vue?vue&type=script&lang=js"
export * from "./AuthPopup.vue?vue&type=script&lang=js"

import "./AuthPopup.vue?vue&type=style&index=0&id=913abc7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__